export function vaccinePayload(form, requestKey) {
    const text = value => String(value == null ? '' : value).trim()
    const payload = {
        reference: text(form.reference).toUpperCase(), libelle: text(form.libelle),
        conditionnement: text(form.conditionnement), doses_par_flacon: Number(form.doses_par_flacon),
        fabricant: text(form.fabricant) || null, notes: text(form.notes) || null,
    }
    if (form.id) payload.version = form.version
    else payload.request_key = requestKey
    return payload
}

export function newVaccineRequestKey() {
    const bytes = window.crypto.getRandomValues(new Uint8Array(16))
    bytes[6] = (bytes[6] & 15) | 64
    bytes[8] = (bytes[8] & 63) | 128
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
    return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`
}
